/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MeevoTheming {
    "use strict";

    export class MeevoThemingContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected themingModel: any;
        protected businessTypeDetail: Model.DataDetail;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            public interopService: Meevo.Plugins.Interop.InteropService
            
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
                this.baseEndpoint = appSettings.API_ENDPOINTS.meevoTheming;
                this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_TASKBAR);
           

            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/meevoTheming/sectionViews/";
            this.initializeSections();
        }

        initializeSections(): void {
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_TASKBAR + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(1, "SECTION_MANAGEMENT_TASKBAR", "main.html", true, true,
                    this.baseEndpoint, "", this.loggingService, this.dataService, Meevo.Model.NounEnum.MeevoThemingTaskbar, this.identityService, this, this.onSaveUpdate.bind(this), this.postCancel.bind(this), this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_TASKBAR + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_SMARTCENTER + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new SmartCenterThemingSection(2, "SECTION_MANAGEMENT_SMARTCENTER", "smartcenters.html", false, true,
                    this.baseEndpoint, "", this.loggingService, this.dataService, Meevo.Model.NounEnum.MeevoThemingSmartCenter, this.identityService,this, this.onSaveUpdate.bind(this), this.postCancel.bind(this), this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_SMARTCENTER + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_DATAMAINT + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new DataMaintSection(3, "SECTION_MANAGEMENT_DATAMAINT", "dataMaint.html", false, true,
                    this.baseEndpoint, "", this.loggingService, this.dataService, Meevo.Model.NounEnum.MeevoThemingDataMaint, this.identityService, this, this.onSaveUpdate.bind(this), this.postCancel.bind(this), this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_DATAMAINT + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            this.activate();
        }

        initializeHeader(model: any): void {
            if (this.isApplicationModeCO() || this.isSingleLocation())
                model.businessTypeDetail = this.businessTypeDetail;
        }

        selectSection(item): void {
            

            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_TASKBAR, false, false);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_SMARTCENTER, false, false);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_MEEVOTHEMING_TAB_DATAMAINT, false, false);
                    break;

            }

           super.selectSection(item);
        }

  
    

        /**
        * Gets or set the holidayType value
        */
        private _holidayTypeDetail: Model.IntDetail;

        get holidayTypeDetail(): Model.IntDetail {
            return this._holidayTypeDetail;
        }

        set holidayTypeDetail(value: Model.IntDetail) {
            this._holidayTypeDetail = value;
            if (Model.Guard.isNothing(this._holidayTypeDetail))
                return;
            let request = { holidayTypeId: this._holidayTypeDetail.id };
            this.dataService.getListPaged("/Tenant/HolidayTypeHolidays", request)
                .then(response => { this.holidayTypeHolidays = response; });
        }

        /**
        * Gets or set the Holidays for the selected holidayType value
        */
        private _holidayTypeHolidays: Model.HolidayLocal[];

        //get holidayTypeHolidays(): Model.HolidayLocal[] {
        //    return this._holidayTypeHolidays;
        //}

        //set holidayTypeHolidays(value: Model.HolidayLocal[]) {
        //    this._holidayTypeHolidays = value;
        //    this.updateChangeState();
        //}

        private updateChangeState() {
            let context = this;
            if (!context || !context._holidayTypeHolidays || !context.selectedSection.model.holidays)
                return;
            var businessHolidays = context.selectedSection.model.holidays;
            if (businessHolidays.length === 0)
                return;
            // When business holidays are available, hide any existing in holidayTypeHolidays
            _.each(context._holidayTypeHolidays, hth => {
                hth.hide = _.any(businessHolidays, h => (<Model.Holiday>h).displayName === hth.displayName);
            });
        }
        /**
        * Opens a modal to create or edit a holiday item.
        * @param context
        */
        openHolidayEditor(context: any, _holiday: Model.Holiday) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/holiday/sectionViews/holidayEditor.html",
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    holidayItem: _holiday
                },
                controller: "meevo.plugins.HolidayEditorController",
                controllerAs: "vm"
            }
            if (_holiday === null) {
                let trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.HolidaysMain, Meevo.Model.VerbEnum.CreateHolidayButtonClicked, null, null);
                this.trackingService.saveTrackingInfo(trackingItem);
            } else {
                let trackingItem = new Meevo.Model.TrackingItem(Meevo.Model.NounEnum.HolidaysMain, Meevo.Model.VerbEnum.EditHolidayButtonClicked, null, _holiday.id);
                this.trackingService.saveTrackingInfo(trackingItem);
            }


            this.modalService.showCustom(options);
        }



       

        removePastHoliday(holiday: Model.Holiday): void {
            let selectedHolidaySet = this.selectedSection.model.pastHolidays;
            //selectedHolidaySet[0].isDelete = true;
            var selectedHoliday = moment(holiday.holidayDate).format("MMM Do YY");

            _.each(selectedHolidaySet, (h: Model.Holiday, key) => {
                if (Model.Guard.isSomething(h) && moment(h.holidayDate).format("MMM Do YY") == selectedHoliday) {
                    selectedHolidaySet.splice(key, 1);
                }
            });
        }

        revertTaskbar() {
            let previousSelectedColors = this.selectedSection["previousColors"]

            this.selectedSection["respObj"]["colors"]["taskbarColor"] = previousSelectedColors["taskbarColor"];
            this.selectedSection["respObj"]["colors"]["taskbarTabsColor"] = previousSelectedColors["taskbarTabsColor"]

            //revert taskbar
            let taskbar = document.getElementById('meevo-navbar');
            let taskbarColor = previousSelectedColors["taskbarColor"];
            taskbar.style.setProperty(`background-color`, ` ${taskbarColor}`, `important`)

            //revert Active Tab Color
            const head = document.getElementsByTagName('head')[0];
            const tabsElement = document.getElementById("taskbarTabsStyle")
            if (tabsElement) {
                tabsElement.remove();
            }
            // apply saved css if not on refresh
            const style = document.createElement('style');
            const css = `.meevo-navbar .context-container.context-active{background-color: ${previousSelectedColors["taskbarTabsColor"]}}`
            style.type = 'text/css';
            style.id = "taskbarTabsStyle"
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);

            //revert menu theme
            this.revertMenu();
        }
        smartCenterRevert() {

            let previous = this.selectedSection["previousColors"];

            this.selectedSection["respObj"]["colors"]["smartCenterColor1"] = previous["color1"]
            this.selectedSection["respObj"]["colors"]["smartCenterColor2"] = previous["color2"]
            this.selectedSection["respObj"]["colors"]["smartCenterName"] = previous["name"]

            const head = document.getElementsByTagName('head')[0];
            const smartCenterElement = document.getElementById("smartCenterStyle")
            if (smartCenterElement) {
                smartCenterElement.remove();
            }

            const smartCenterColor = `.smart-center-designer-root .gridster{background: radial-gradient(${previous["color1"]},${previous["color2"]})}`
            const style = document.createElement('style');
            const css = `.smart-center-root, .smart-center-root.salon{background: radial-gradient(${previous["color1"]},${previous["color2"]})}` /*+ smartCenterColor*/
            style.type = 'text/css';
            style.id = "smartCenterStyle"
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);


        }
        revertDataMaint() {

            let previous = this.selectedSection["previoustheme"]

            if (previous !== 0) this.selectedSection["themes"][0].enabled = undefined;
            if (previous !== 1) this.selectedSection["themes"][1].enabled = undefined;
            if (previous !== 2) this.selectedSection["themes"][2].enabled = undefined;

            if (previous == 0) this.selectedSection["themes"][0].enabled = false;
            if (previous == 1) this.selectedSection["themes"][1].enabled = false;
            if (previous == 2) this.selectedSection["themes"][2].enabled = false;

            this.selectedSection["themeSelected"] = previous;

            let dataMaintElement = document.getElementById("dataMaintStyle");
            if (dataMaintElement) {
                dataMaintElement.remove();
            }
            let themesCss = this.selectedSection["themesCss"]
            let index = previous;
            //applying previous theme 
            let meevo_bottom_tray = `.meevo_save_delete_bottom_tray{background-color: ${themesCss[index].meevo_bottom_tray} }`
            let maint_side_nav = `.maint-side-nav{background-color: ${themesCss[index].maint_side_nav}}`
            let nav_buttons_active = `.nav_buttons_active{ background-color: ${themesCss[index].nav_buttons_active} !important}`
            let nav_buttons = `.nav-buttons{ background-color: ${themesCss[index].nav_buttons}}`
            let maint_subheader = `.maint-subheader .maint-name{background-color: ${themesCss[index].maint_subheader}}`
            let meevo_button = `.meevo_save_delete_bottom_tray .meevo-button{background-color: ${themesCss[index].meevo_button}}`
            let hover = `.nav-buttons:hover{ background-color: ${themesCss[index].hover}}`
            let search_again = `.maint-subheader .search-again{background-color: ${themesCss[index].search_again}}`

            //mobile
            let mobileSaveButton = `#maint-crud-mobile .meevo-button {background-color: ${themesCss[index].meevo_button}}`;
            let mobileHamburger = `#showMobileMenuButton { background-color: ${themesCss[index].meevo_button} !important}`;

            // themeCss SINGULAR without s not confused with themesCss is the whole css string
            let themeCss = meevo_bottom_tray + maint_side_nav + nav_buttons_active + nav_buttons + maint_subheader + meevo_button + hover + search_again;

            const head = document.getElementsByTagName('head')[0];

            const style = document.createElement('style');
            const css = themeCss;
            style.type = 'text/css';
            style.id = "dataMaintStyle"
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);
        }
        revertMenu() {
            //revert menu theming
            let previousSelectedColors = this.selectedSection["previousColors"]
            //let menuTheme = previousSelectedColors.menuTheme
            let menuTheme = this.selectedSection["menu_themes"][previousSelectedColors.menuTheme]
            let buttonColor = menuTheme.click;
            let backgroundColor = menuTheme.background;
            let hoverColor = menuTheme.hover;

            const head = document.getElementsByTagName('head')[0];
            const tabsElement = document.getElementById("menuActiveButton")
            if (tabsElement) {
                tabsElement.remove();
            }
            const style = document.createElement('style');
            const hoverCss = `.side-menu:hover{background-color: ${hoverColor}}`
            const backgroundCss = `.meevo-second-menu {background-color: ${backgroundColor} !important}`
            const menuButtoncss = `.menu_item_active{background-color: ${buttonColor} !important}`

            //mobile background
            const mobileMenuBackground = `.meevo-second-menu-phone{background-color: ${backgroundColor} !important}`
            const compileCss = hoverCss + backgroundCss + menuButtoncss + mobileMenuBackground;

            style.type = 'text/css';
            style.id = "menuActiveButton";
            style.appendChild(document.createTextNode(compileCss));
            head.appendChild(style);
            //this.selectedSection.selected_menu_theme = menuTheme;
           
            this.selectedSection["selected_menu_theme"] = previousSelectedColors.menuTheme;
        }
        revertColors() {
            if (this.selectedSection === this.sections[0]) {
                //taskbar reset
                this.revertTaskbar();

            } else if (this.selectedSection === this.sections[1]) {
                //smartcenter reset
                this.smartCenterRevert();
            }
            else if (this.selectedSection === this.sections[2]) {
                //dataMaint reset
                this.revertDataMaint();
            }
        }


        postCancel() {
            this.revertColors();
            this.holidayTypeDetail = undefined;
            super.postCancel();
        }

        onSaveUpdate() {
            let selectedSection = this.selectedSection;
            let sections = this.sections;
            if (this.selectedSection === this.sections[0]) {
                //taskbar saved
                sections[1]["respObj"] = selectedSection["respObj"]
                sections[2]["respObj"] = selectedSection["respObj"]

            } else if (this.selectedSection === this.sections[1]) {
                //smartcenter saved
                sections[0]["respObj"] = selectedSection["respObj"]
                sections[2]["respObj"] = selectedSection["respObj"]
            }
            else if (this.selectedSection === this.sections[2]) {
                //data maint
                sections[0]["respObj"] = selectedSection["respObj"]
                sections[1]["respObj"] = selectedSection["respObj"]

                //send new color theme
                this.interopService.pushToAllChild(Meevo.Components.Common.Messages.SET_NEW_COLOR_THEME, selectedSection["respObj"]);

            }

        }

        save(): angular.IPromise<any> {
            console.log("save")
            this.onSaveUpdate();
            //if (Model.Guard.isSomething(this.selectedSection.model.businessTypeDetail))
            //    this.selectedSection.baseEndpoint = this.appSettings.API_ENDPOINTS.meevoTheming 
            //else
            //    this.selectedSection.baseEndpoint = this.appSettings.API_ENDPOINTS.meevoTheming 

            //if (this.selectedSection.displayNameContentKey === "SECTION_BUSINFO_MANAGE_PAST_HOLIDAYS") {
            //    this.selectedSection.baseEndpoint = "PastHolidays/" + this.selectedSection.baseEndpoint;
            //}
            return super.save().then((data: any) => {
                this.holidayTypeDetail = undefined;
            });
        }

        edit(): void {
            var cultureholidayTypeDetail: Model.IntDetail = { displayName: "", id: 1 };
            var cultureCountry = this.appSettings.APP_ISOCOUNTRYCODE;

            switch (cultureCountry) {
                case 'UK':
                case 'GB':
                    cultureCountry = 'UK';
            }
            cultureCountry = cultureCountry + " Holidays";
            this.dataService.customMethodData('api/tenant/holidaytypes/List', 'GET', '', null).then((results: any) => {
                var item = results.data;
                _.find(item, (sl: any) => {
                    if (sl.displayName === cultureCountry) {
                        cultureholidayTypeDetail.id = sl.id;
                        cultureholidayTypeDetail.displayName = sl.displayName;
                        this.holidayTypeDetail = cultureholidayTypeDetail;
                        return true;
                    }
                });
                super.edit();
            });
        }

        updateTextelSystemAutoReply() {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TEXTEL_UPDATE_SYSTEM_AUTO_REPLY_TIMER);
        }
    }
}